<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Siunčiamų dokumentų žurnalas') }}</h1>
    <!-- search -->
    <admin-journal-notification-search
      @downloadReport="downloadReport"
      :loading="loading"
      @search="searchInstitutions"
    />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->

      <!--main custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
          
            :item="setItemParam(item)"
            @viewItem="viewItem(item)"
            @viewInModaltem="viewInModaltem(item)"
            @downloadItem="download(item)"
            @deleteItem="deleteItem(item)"
          />
        </div>
      </template>
      <template #[`item.out_journal_type`]="{ item }">
        <el-table-enum
          enumName="outJournalType"
          :item="item.out_journal_type"
        />
      </template>
       <template #[`item.status`]="{ item }">
        <el-table-enum
          enumName="msgStatusTypes"
          :item="item.status"
        />
      </template>
      <template #[`item.sent_mode`]="{ item }">
        <el-table-enum enumName="sentMode" :item="item.sent_mode" />
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
    <modal-confirm
      :title="viewModalTitle"
      :text="viewModalText"
      v-model="showViewModal"
      info
      :loading="loading"
    />
  </v-container>
</template>

<script>
import AdminJournalNotificationSearch from './AdminJournalNotificationSearch'
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import ModalConfirm from '@/components/modals/ModalConfirm'
import math from '@/mixins/math'
import Enums from '@/enums'
import tableParameters from '@/mixins/tableParameters'

export default {
  name: 'JournalNotification',
  components: {
    AdminJournalNotificationSearch,
    ModalDelete,
    ModalConfirm,
  },
  mixins: [userRole, math, tableParameters],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteItem: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },

      showViewModal: false,
      viewModalTitle: "",
      viewModalText: "",
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Siųsto pranešimo registracijos Nr.'),
          align: 'start',
          value: 'out_journal_no',
        },
        {
          text: this.$t('Siuntimo būdas'),
          align: 'start',
          value: 'sent_mode',
        },
        {
          text: this.$t('Adresato asmens kodas'),
          align: 'start',
          value: 'addressee_code',
        },
        {
          text: this.$t('Adresatas'),
          align: 'start',
          value: 'addressee_fullname',
        },
        {
          text: this.$t('Telefono Nr.'),
          align: 'start',
          value: 'addressee_phone',
        },
        {
          text: this.$t('Adresato el. paštas'),
          align: 'start',
          value: 'addressee_email',
        },
        {
          text: this.$t('Registro pranešimas'),
          align: 'start',
          value: 'out_journal_type',
        },
        {
          text: this.$t('Būsena'),
          align: 'start',
          value: 'status',
        },
        {
          text: this.$t('Siuntimo data'),
          align: 'start',
          value: 'sent_at',
        },
        {
          text: this.$t('Registracijos Nr. gautų dok. žurnale'),
          align: 'start',
          value: 'in_journal_no',
        },
        {
          text: this.$t('Identifikavimo kodas'),
          align: 'start',
          value: 'mandate_code',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {},
  created() {
    // this.setlistParams()
  },
  methods: {
    viewInModaltem(item){
      this.showViewModal = true
      this.viewModalTitle = Enums.sentMode.lt[item.sent_mode]
      this.viewModalText = ''
      if (item.status == '02') {
        this.viewModalText += 'Klaidos pranešimas:<hr>' + item.error_message + '<hr><br>Tekstas:<hr>'
      }
      this.viewModalText += item.text || ""

    },
    viewItem(item) {
      this.$router.push({
        name: 'adminJournalNotificationView',
        params: {
          id: item.upload_id,
        },
      })
    },
    setItemParam(item) {
      if(item.canDownload){
        item.canView = true
      }
      if(item.sent_mode == 'sms' || item.sent_mode == 'email'){
         item.canViewInModal = true
      }
      return item
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`out-journals/list`, data)
        .then((res) => {
          this.listData = res.data.outJournals
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
          page: pagination.page,
          route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchInstitutions(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    download(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.upload_id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    downloadReport() {
      this.loading = true
      const data = {
        ...this.pagination,
        search: this.searchData,
        isReport: true,
      }
      this.$axios
        .post(`out-journals/list`, data)
        .then((res) => {
           this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },

    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },

    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`journal-notification/${item.id}`)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE', '000111')
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
